module.exports = __webpack_public_path__ + "img/img-fa5585.png";